module.exports = __webpack_public_path__ + "static/media/Badge_PngMarqueMiniParcours_Cerave_disabled.3b964d7a.png";